/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Directive, HostListener, Input } from '@angular/core';
import { OffDeviceLinkService } from '../services/off-device-link.service';

export interface NvAnchorOffDeviceConfig {
    defaultTitle: string;
    primaryButtonText: string;
}

/**
 * Prevents opening popups when clicking on anchor elements (<a>) when off-device link feature is enabled.
 * If the anchor element is inserted at runtime, then this directive needs to be explicitly enabled on its ancestor element.
 */
@Directive({
    selector: '[nvOffDeviceLink], a[href], *[innerHTML], *[innerHtml]',
    standalone: true
})
export class OffDeviceLinkDirective {
    /**
     * A user friendly version of the link which will be displayed to the user when specified.
     */
    @Input() shortUrl?: string;

    constructor(private offDeviceLinkService: OffDeviceLinkService) {}

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        const target = event.target;
        if (this.offDeviceLinkService.enabled && target instanceof HTMLAnchorElement && target.href) {
            const shortUrl = this.shortUrl ?? target.getAttribute('shortUrl') ?? '';
            event.preventDefault();
            this.offDeviceLinkService.open(target.href, { shortUrl });
        }
    }
}
